import API from '../../../../../services/api';

export const PLATAFORMAS_API = {
    getCurrentRFClearence: async () => {
        return API.get('/plataformas/getCurrentRFClearence').then(
            (res) => res.data,
        );
    },
    udateRFClearence: async (newValue) => {
        return API.post('/plataformas/updateRFClearence', { newValue }).then(
            (res) => res.data,
        );
    },
};
